module.exports = function(dispatcher) {
  return function(size) {
    dispatcher.dispatch({
      type: 'updateSize',
      size
    });
  };
};
